import { Component, forwardRef, Input } from '@angular/core';
import { DestroySubscribers } from '../../../../decorators/destroy-subscribers.decorator';
import { FormWithHintAbstract } from '../abstract/form-with-hint.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'gtd-radio-group-with-hint',
  templateUrl: './radio-group-with-hint.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => RadioGroupWithHintComponent),
    },
  ],
})
@DestroySubscribers()
export class RadioGroupWithHintComponent extends FormWithHintAbstract {
  @Input() public data: { [key: string]: any };
  @Input() hintModal: boolean;
  @Input() name: string;
}
